module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e13-ddb7d89e383b097e3d18d05f56c1f077.jpg";